module.exports = __webpack_public_path__ + "static/img/pantos.fdeba21.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/pantos.jpg
// module id = ACg3
// module chunks = 0